import { useNavigation } from '@react-navigation/native';
import AccountContext from 'context/AccountContext';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountNavProps } from 'types/navigation';
import { showFeatureFlag } from 'utils/featureFlagUtils';
import { MenuItemWrapped, MenuSection } from './MenuComponents';

const HistoryMenu = () => {
  const { navigate } = useNavigation<AccountNavProps>();
  const { t } = useTranslation();
  const {
    flags: { account_rides },
  } = useContext(FeatureFlagsContext);
  const {
    customer: { aimoPlusSubscriber },
  } = useContext(AccountContext);
  const showAccountRide = showFeatureFlag(account_rides);

  return (
    <MenuSection headline={t('account.history')}>
      <MenuItemWrapped
        menuLabel={t('account.parkAndCharge')}
        iconName="History-Outlined"
        testID="parking-history-link"
        onPress={() => navigate('parkingHistory')}
      />
      {showAccountRide && (
        <MenuItemWrapped
          menuLabel={t('account.rides')}
          iconName="History-Outlined"
          testID="rides-history-link"
        />
      )}
      <MenuItemWrapped
        menuLabel={t('account.prepaid')}
        iconName="History-Outlined"
        testID="prepaid-history-link"
        noBorder={!aimoPlusSubscriber}
        onPress={() => navigate('prepaidHistory')}
      />
      {aimoPlusSubscriber && (
        <MenuItemWrapped
          menuLabel={t('account.aimoSubscription.title')}
          iconName="History-Outlined"
          testID="subscription-history-link"
          noBorder
          onPress={() => navigate('prepaidHistory', { isSubscription: true })}
        />
      )}
    </MenuSection>
  );
};

export default HistoryMenu;
